import React from 'react'
import { IconButtonGroupProps } from './types'
import { Button, Tooltip } from 'antd'
import styles from './IconButtonGroup.module.scss'
import { ModalProvider } from '@shared/Modal'
export function IconButtonGroup(props: IconButtonGroupProps) {
  const { buttons } = props

  return (
    <div
      style={{
        display: 'inline-flex',
        gap: 10,
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '16px',
        border: '1px solid #E6E6E6',
        borderRadius: '12px',
      }}
    >
      {buttons.map((button) => {
        return button.modal ? (
          <ModalProvider
            {...button.modal}
          >
            {({ openModal }) => (
              <Tooltip className="footer-tooltip" title={button.title}>
                <Button
                  className={button.disabled ? styles.buttonDisabled : ''}
                  shape="circle"
                  type="default"
                  icon={button.icon}
                  disabled={button.disabled}
                  size="large"
                  onClick={() => {
                    openModal('')
                    button.onClick()
                  }}
                  style={{
                    border: 'none',
                    boxShadow: '0px 4px 15px #ccd2d980, 0px 0px 8px #ccd2d980',
                  }}
                />
              </Tooltip>
            )}
          </ModalProvider>
        ) : (
          <Tooltip className="footer-tooltip" title={button.title}>
            <Button
              className={button.disabled ? styles.buttonDisabled : ''}
              shape="circle"
              type="default"
              icon={button.icon}
              disabled={button.disabled}
              size="large"
              onClick={button.onClick}
              style={{
                border: 'none',
                boxShadow: '0px 4px 15px #ccd2d980, 0px 0px 8px #ccd2d980',
              }}
            />
          </Tooltip>
        )
      })}
    </div>
  )
}
